<template>
    <p class="empty-text">
        {{ emptyText }}
    </p>
</template>

<script>
    export default {
        props: {
            emptyText: String
        }
    }
</script>